<template>
    <div class="quick-declare-button-set">
        <!-- 步驟提示 -->
        <div class="step-hint-bar">
            <div v-if="!isLoading">
                <div v-if="data.length > 0">
                    <div class="guide-title">
                        <!--本期未申報共 {{ totalDataCount }} 筆，-->
                        <template v-if="type === 'invoice'">請勾選項目並「列入申報本期」，至清空列表。</template>
                        <template v-if="type === 'payment'">請勾選項目並標記為「列入申報本期」或「列入不申報扣抵」，至清空列表。</template>
                    </div>
                </div>
                <div v-else>
                    <span class="guide-title" style="margin-right: 10px; display: flex; gap: 10px; align-items: center;">
                        <i class="el-icon-check" style="font-size: 18px;"></i>
                        <span style="margin-right: 10px;">未申報項目已清空</span>
                        <el-button v-if="currentStepNum === 2" size="mini" @click="goToStep(3)" type="warning">下一步</el-button>
                        <el-button v-if="currentStepNum === 3" size="mini" @click="goToStep(4)" type="warning">下一步</el-button>
                    </span>
                </div>
            </div>
        </div>
        <div class="filter-bar">
            <!-- 批次動作 -->
            <div v-if="selectedItems.length > 0" class="batch-action">
                <div>
                    <span style="margin-right: 15px">已勾選 {{ selectedItems.length }} 筆</span>
                    <el-button v-if="isAutoCodeShow" size="mini" v-loading="isLoading" icon="el-icon-magic-stick" @click="onAutoChangeCode">自動格式代號</el-button>
                    <el-tooltip class="item" effect="dark" content="尚有項目未定格式代號" :manual="!(selectedItems.length && isDeclareBtnDisabled)" placement="top">
                        <el-button
                            type="primary"
                            size="mini"
                            v-loading="isLoading"
                            :disabled="isDeclareBtnDisabled"
                            @click="onMarkDeclareStatus"
                        > 列入申報 {{ declarePeriodText }}</el-button>
                    </el-tooltip>
                    <span v-if="!isIncome" style="margin: 0 8px">或</span>
                    <el-button v-if="!isIncome" type="warning" size="mini" v-loading="isLoading" @click="onMarkNonDeclareStatus"> 列入不申報扣抵 </el-button>
                    <span v-if="isSelectedIncludeNonPayed" class="warning" style="color: #E6A23C; margin-left: 25px;">
                        <span><i class="el-icon-warning"></i> 有進項發票「待付款」，請留意 </span>
                        <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-saving-manual/national/business-tax/56wPPg9" style="color: #E6A23C" target="_blank">財政部錯誤受罰案例</a>
                    </span>
                </div>

            </div>
            <!-- <div class="upper" v-if="type !== 'invoice'">
                <div class="upper-inner">
                    <div class="label">資料來源：</div>

                    <div class="time-query-block">
                        <div v-if="!dataSource">
                            <el-select v-model="year" :disabled="isTimeQueryDisabled" style="width: 120px; margin-right: 10px" size="small" @change="onPeriodChange">
                                <el-option v-for="year in yearList" :key="year.value" :label="year.label" :value="year.value"></el-option>
                            </el-select>
                            <el-radio-group v-model="period" :disabled="isTimeQueryDisabled" size="small" @change="onPeriodChange">
                                <el-radio-button v-for="item in dateList" :key="item.value" :label="item.value">{{ item.period }} </el-radio-button>
                            </el-radio-group>
                        </div>

                    </div>
                </div>
                <div v-if="!isIncome && isPayed('D21')">
                    <el-radio-group v-model="paymentType" size="small" @change="onPaymentTypeChange">
                        <el-radio-button label="Payment">請款單</el-radio-button>
                        <el-radio-button label="PaymentInvoice">外部進項發票</el-radio-button>
                    </el-radio-group>
                </div>
            </div> -->
            <div class="lower">
                <!-- 篩選搜尋 -->
                <div class="query-block">
                    <template v-if="type !== 'invoice'">
                        <template v-if="!isIncome && isPayed('D21')">
                            <el-radio-group v-model="paymentType" size="small" @change="onPaymentTypeChange">
                                <el-radio-button label="Payment">請款單</el-radio-button>
                                <el-radio-button label="PaymentInvoice">外部進項發票</el-radio-button>
                            </el-radio-group>
                        </template>
                        <el-radio-group size="small" v-model="dataSource" :disabled="isTimeQueryDisabled" @change="onDateSourceChange">
                            <el-radio-button :label="0">期別</el-radio-button>
                            <el-radio-button :label="1">日期範圍</el-radio-button>
                        </el-radio-group>
                        <template v-if="dataSource === 0">
                            <el-select v-model="year" :disabled="isTimeQueryDisabled" style="width: 90px;" size="small" @change="onPeriodChange">
                                <el-option v-for="year in yearList" :key="year.value" :label="year.label" :value="year.value"></el-option>
                            </el-select>
                            <el-select v-model="period" :disabled="isTimeQueryDisabled" style="width: 110px; margin-left: -11px;" size="small" @change="onPeriodChange">
                                <el-option v-for="item in dateList" :key="item.value" :label="item.period" :value="item.value">{{ item.period }}</el-option>
                            </el-select>
                        </template>
                        <template v-if="dataSource === 1">
                            <ahSelectTimeRange
                                v-model="timespan"
                                :disabled="isTimeQueryDisabled"
                                picker-only
                                default="month"
                                label="單據時間範圍"
                                size="small"
                                :clearable="false"
                                @change="onTimespanChange"
                            />
                        </template>
                    </template>
                    <el-input v-model="foo" placeholder="發票號碼" size="small" style="width: 160px" @keydown.enter.native="onSearch" />
                    <el-input v-model="bsn" :placeholder="isIncome ? '買方統編' : '賣方統編'" size="small" style="width: 130px" @keydown.enter.native="onSearch" />
                    <money-input v-model="amt" placeholder="含稅金額" size="small" is-search style="width: 130px" @keydown.enter.native="onSearch" />
                </div>
                <div>
                    <span class="data-count-summary">共 {{ totalDataCount }} 筆 ({{ pageCount }} 頁)</span>
                    <!-- <span v-if="!isIncome" class="data-count-summary">；不申報扣抵項目請至 “查詢總表” 瀏覽。</span> -->
                </div>
            </div>
        </div>
        <DeclaredHintDialog :visible="declaredHintDialog.visible" :count="declaredHintDialog.count" @close="onCloseDeclaredHintDialog" />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import {
    mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import ExcelMixins from '@/components/dashboard/Accounting/BusinessTax/ExcelMixins';
import DeclaredHintDialog from '@/components/dashboard/Accounting/BusinessTax/DeclaredHintDialog.vue';
import ahSelectTimeRange from '@/components/ui/ahSelectTimeRange.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';

export default {
    components: { ahSelectTimeRange, DeclaredHintDialog },
    mixins: [ExcelMixins],
    props: {
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            year: 0,
            yearList: [],
            dateList: [
                { period: '1～2月', value: 1 },
                { period: '3～4月', value: 2 },
                { period: '5～6月', value: 3 },
                { period: '7～8月', value: 4 },
                { period: '9～10月', value: 5 },
                { period: '11～12月', value: 6 },
            ],
            dataSource: 0,
            timespan: null,
            foo: null,
            bsn: null,
            amt: null,

            declaredHintDialog: {
                visible: false,
                count: 0,
            },

            paymentType: 'Payment',
        };
    },
    created() {
        const PERIOD_LIST_YEAR = this.periodList.length / 6;
        const THIS_YEAR = moment().year();
        for (let i = 0; i <= PERIOD_LIST_YEAR; i += 1) {
            const YEAR = THIS_YEAR - i;
            this.yearList.push({ label: `${YEAR - 1911}年`, value: YEAR });
        }
        this.year = _.find(this.yearList, ['value', this.declarePeriodYear]).value;

        if (!this.$route.query.period) {
            this.dataSource = 1;
            this.$nextTick(() => {
                this.onDateSourceChange(1);
            });
        }
    },
    computed: {
        ...mapState({
            isLoading: (state) => state.businessTax.isLoading,
            selectedItems: (state) => state.businessTax.selectedItems,
            selectedInvoiceItems: (state) => state.businessTax.selectedInvoiceItems,
            selectedPaymentItems: (state) => state.businessTax.selectedPaymentItems,

            data: (state) => state.businessTax.datas,
            periodList: (state) => state.businessTax.periodList,
            queryParams: (state) => state.businessTax.queryParams,
            isIncome: (state) => state.businessTax.queryParams.QueryType === 1,
            currentTableVueComponent: (state) => state.businessTax.currentTableVueComponent,
            totalDataCount: (state) => state.businessTax.totalDataCount,

            declarePeriod: (state) => state.businessTax.declarePeriod,
            declarePeriodYear: (state) => state.businessTax.declarePeriodYear,
            declarePeriodText: (state) => {
                const PERIOD_OBJECT = _.find(state.businessTax.periodList, {
                    year: state.businessTax.declarePeriodYear,
                    value: state.businessTax.declarePeriod,
                });
                return PERIOD_OBJECT ? `${PERIOD_OBJECT.year - 1911}年 ${PERIOD_OBJECT.period}` : '--';
            },
            statePeriod: (state) => state.businessTax.period,
            stateTimespan: (state) => state.businessTax.timespan,
            currentStepNum() {
                const stepTxt = this.$route.path.split('/').pop();
                if (stepTxt === 'step1') return 1;
                if (stepTxt === 'step2') return 2;
                if (stepTxt === 'step3') return 3;
                if (stepTxt === 'step4') return 4;
                return 0;
            },
            pageCount() {
                return Math.ceil(this.totalDataCount / this.queryParams.PageSize);
            },
        }),
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
        isMediaFileExportable() {
            if (!this.selectedItems.length) return false;

            const notExportableInvoiceList = this.selectedInvoiceItems.filter((row) => !row.code || (row.typ === 3 && !row.bsn) || !row.foo || row.typ === 1);
            const notExportablePaymentList = this.selectedPaymentItems.filter((row) => row.declareStatus === 2 || !row.code || !row.bsn || !row.foo);
            return notExportableInvoiceList.length === 0 && notExportablePaymentList.length === 0;
        },

        isDeclareBtnDisabled() {
            const INVALID_DATA_LIST = this.selectedItems.filter((o) => !o.code || o.code === '0');
            return !this.selectedItems.length || !!INVALID_DATA_LIST.length;
        },
        isBatchMarkNonDeclare() {
            return !this.isIncome && Number(this.$route.query.TaxDeclareStatus) === 1;
        },
        isBatchMarkNonDeclareDisabled() {
            return !this.selectedPaymentItems.length;
        },
        isAutoCodeShow() {
            return this.selectedItems.length;
        },
        isTimeQueryDisabled() {
            return this.$route.name === 'accounting-business-tax-quick-declare-step-2';
        },
        isSelectedIncludeNonPayed() {
            return this.selectedItems.find((o) => o.sigN_STS === 5);
        },

        period: {
            get() {
                return this.statePeriod;
            },
            set(val) {
                this.setPeriod(val);
            },
        },
    },
    methods: {
        ...mapMutations({
            onClearSelection: 'businessTax/onClearSelection',
            updateQuery: 'businessTax/updateQuery',
            setPeriod: 'businessTax/setPeriod',
            setTimespan: 'businessTax/setTimespan',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
            updateDeclaredData: 'businessTax/updateDeclaredData',
        }),
        onSelectAll() {
            this.currentTableVueComponent.$refs.table.toggleAllSelection();
        },
        async onMarkDeclareStatus() {
            try {
                const INVOICE_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.ioo)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: true,
                        updateType: o.typ > 0 ? 1 : 2,
                        prefixYear: this.declarePeriodYear,
                        prefixMonth: this.declarePeriod,
                    }))
                    .value();

                const TRAN_INVOICE_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.isTranInovice)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: true,
                        updateType: o.typ > 0 ? 1 : 2,
                        prefixYear: this.declarePeriodYear,
                        prefixMonth: this.declarePeriod,
                    }))
                    .value();

                const TCIN_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.taxCredited)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: 1,
                        prefixYear: this.declarePeriodYear,
                        prefixMonth: this.declarePeriod,
                    }))
                    .value();
                const NON_TCIN_LIST = _.chain(this.selectedItems)
                    .filter((o) => o.payoo)
                    .map((o) => ({
                        sno: o.sno,
                        declareStatus: 1,
                        prefixYear: this.declarePeriodYear,
                        prefixMonth: this.declarePeriod,
                    }))
                    .value();

                const errorList = [];

                if (INVOICE_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                        data: { invoices: INVOICE_LIST, invoiceType: 1 },
                        method: 'POST',
                    });
                }
                if (TRAN_INVOICE_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                        data: { invoices: TRAN_INVOICE_LIST, invoiceType: 2 },
                        method: 'POST',
                    });
                }
                if (TCIN_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePaymentInvoiceDeclareStatus',
                        data: { payments: TCIN_LIST },
                        method: 'POST',
                    });
                }
                if (NON_TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayment401DeclareStatus',
                        data: { payments: NON_TCIN_LIST },
                        method: 'POST',
                    });
                    if (resp.data?.fail) errorList.push(...resp.data.fail);
                }

                const count = this.$route.name === 'accounting-business-tax-quick-declare-step-2' ? INVOICE_LIST.length : TCIN_LIST.length + NON_TCIN_LIST.length;

                this.updateData();
                this.updateDeclaredData();
                this.onClearSelection();

                if (errorList.length) {
                    await this.$msgbox({
                        title: '',
                        message: `以下來源請款單已被退件或未審核，${errorList.length} 筆項目無法列入申報：\n${errorList.join(', ')} `,
                        confirmButtonText: '我瞭解了',
                        closeOnClickModal: false,
                        showClose: false,
                    });
                    return;
                }
                this.$message({
                    showClose: true,
                    message: `已將 ${count} 筆項目加入 ${this.declarePeriodText} 申報`,
                    type: 'success',
                });
            } catch (e) {
                console.log(e);
            }
        },

        async onMarkNonDeclareStatus() {
            try {
                const TCIN_LIST = _.chain(this.selectedPaymentItems)
                    .filter((o) => o.taxCredited)
                    .map((o) => ({ sno: o.sno, declareStatus: 2 }))
                    .value();
                const NON_TCIN_LIST = _.chain(this.selectedPaymentItems)
                    .filter((o) => o.payoo)
                    .map((o) => ({ sno: o.sno, declareStatus: 2 }))
                    .value();

                if (TCIN_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePaymentInvoiceDeclareStatus',
                        data: { payments: TCIN_LIST },
                        method: 'POST',
                    });
                }
                if (NON_TCIN_LIST.length) {
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayment401DeclareStatus',
                        data: { payments: NON_TCIN_LIST },
                        method: 'POST',
                    });
                }

                this.updateData();
                this.updateDeclaredData();
                this.onClearSelection();

                this.$message({
                    showClose: true,
                    message: `已將 ${TCIN_LIST.length + NON_TCIN_LIST.length} 筆項目列入不可申報`,
                    type: 'success',
                });
            } catch (e) {
                console.log(e);
            }
        },

        onPeriodChange() {
            this.updateQuery({
                Foo: this.foo ? _.toUpper(this.foo) : null,
                Bsn: this.bsn,
                Amt: this.amt,
                period: this.period,
                Year: this.year,
            });
            this.updateData();
        },
        onTimespanChange() {
            console.log('f')
            this.updateQuery({
                Foo: this.foo ? _.toUpper(this.foo) : null,
                Bsn: this.bsn,
                Amt: this.amt,
                period: 0,
                timespan: this.timespan,
            });
            this.updateData();
        },

        onCloseDeclaredHintDialog() {
            this.declaredHintDialog.visible = false;
        },

        async onAutoChangeCode() {
            const target = this.selectedItems;

            const code401s = [];
            target.forEach((item) => {
                const validateCode = this.getValidateCode(item);
                if (validateCode) {
                    code401s.push({
                        sno: item.sno,
                        code: Number(validateCode),
                        taxCredited: item.taxCredited,
                        isTranInovice: item.isTranInovice,
                    });
                }
            });

            const TCIN_LIST = _.filter(code401s, ['taxCredited', true]);
            const NON_TCIN_LIST = _.filter(code401s, (o) => !o.taxCredited && !o.isTranInovice);
            const TRAN_INVOICE_LIST = _.filter(code401s, (o) => o.isTranInovice);

            try {
                await this.$confirm(`確定自動取得 ${target.length} 筆資料的格式代號？`, {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                if (TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayInvoice401Code',
                        data: {
                            updateType: this.isIncome ? 1 : 2,
                            code401s,
                        },
                        method: 'POST',
                    });
                    console.log('UpdateTCIN401Code', resp);
                }

                if (NON_TCIN_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: this.isIncome ? 1 : 2,
                            code401s,
                        },
                        method: 'POST',
                    });
                    console.log('Update401Code', resp);
                }

                if (TRAN_INVOICE_LIST.length) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: 5,
                            code401s,
                        },
                        method: 'POST',
                    });
                    console.log('Tran Update401Code', resp);
                }

                this.$message({
                    showClose: true,
                    message: `已更新 ${code401s.length} 筆格式代號`,
                    type: 'success',
                });
                this.updateData();
            } catch (e) {
                console.log(e);
            }
        },
        getValidateCode(item) {
            if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = item.typ !== undefined;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) {
                return `${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`;
            }
            return undefined;
        },
        onSearch() {
            this.updateQuery({
                Foo: this.foo ? _.toUpper(this.foo) : null,
                Bsn: this.bsn,
                Amt: this.amt,
                period: this.period,
                Year: this.year,
            });
            this.updateData();
        },

        onPaymentTypeChange() {
            if (this.paymentType === 'Payment') {
                this.updateQuery({
                    SearchType: 1,
                    QueryType: 2,
                    TaxDeclareStatus: 1,
                    Foo: null,
                    Bsn: null,
                    Amt: null,
                });
            } else {
                this.updateQuery({
                    SearchType: 1,
                    QueryType: 3,
                    TaxDeclareStatus: 1,
                    Foo: null,
                    Bsn: null,
                    Amt: null,
                });
            }
            this.updateData();
        },

        onDateSourceChange(val) {
            if (val) this.timespan = this.stateTimespan;
        },

        async goToStep(n) {
            try {
                if (n === 4) {
                    await this.$confirm('請留意前幾期中，是否還有未申報的進項項目。', {
                        confirmButtonText: '已全部申報，下一步',
                        cancelButtonText: '我再檢查一下',
                    });
                }
                this.$router.push({ name: `accounting-business-tax-quick-declare-step-${n}` });
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="scss">
.quick-declare-button-set {
    display: flex;
    flex-direction: column;
    width: 100%;

    .step-hint-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        // background-color: #eae9fd;
        background-color: #f7ee9f;
        color: #482911;
        // color: #453d9e;
        border-bottom: 1px solid #eee;

        font-size: 10pt;
        height: 46px;
    }

    .filter-bar {
        position: relative;
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;

        >.batch-action {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #fff;
            z-index: 1;
            font-size: 10pt;
            color: #444;
            padding: 0 20px;

            >div {
                display: flex;
                align-items: center;
            }
        }
    }

    .upper {
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #e1e1e1;
        justify-content: space-between;
        .upper-inner {
            display: flex;
            align-items: center;
            .label {
                font-size: 11pt;
                margin-right: 10px;
            }
            .time-query-block {
                margin-left: 20px;
            }
        }
    }
    .lower {
        display: flex;
        width: 100%;
        padding: 0 20px;
        justify-content: space-between;
        align-items: center;
    }
    .lower .query-block {
        // width: calc(100vw - 330px);
        display: flex;
        align-items: center;
        flex: 1;
        gap: 10px;
        overflow-y: hidden;
        overflow-x: auto;

        .el-radio-group {
            display: flex;
        }

        .el-date-editor.el-date-editor--daterange.el-input__inner {
            width: 250px;
            >.el-range-input {
                width: 42%;
            }
            >.el-range__close-icon {
                display: none;
            }
        }
    }
    .data-count-summary {
        font-size: 10pt;
        color: #878a8f;
        margin-left: 15px;
    }
    .alert-block {
        margin-top: 10px;
    }
}
</style>
